module.exports = __webpack_public_path__ + "media/coins-falling.90dbb0bb.mp4";